<template>
   <a-modal
    title="货品详情"
    :visible="visible"
    :footer="null"
    width="55%"
    class="replenishment-detail"
    @cancel="handleCancel"
  >
    <block-title
      title="货品详情"
      :show-line="false"
      class="descriptions-block"
    >
      <a-descriptions
        bordered
        :column="2"
        class="descriptions"
        size="small"
      >
        <a-descriptions-item label="货品名称">
          {{detail.goodsName}}
        </a-descriptions-item>
        <a-descriptions-item label="货品编码">
          {{detail.shipperGoodsCode}}
        </a-descriptions-item>
        <a-descriptions-item label="货主名称">
          {{detail.customerName}}
        </a-descriptions-item>
        <a-descriptions-item label="货品类别">
          {{detail.goodsTypeName}}
        </a-descriptions-item>
        <a-descriptions-item v-if="detail.supplier" label="供应商">
          {{detail.supplier}}
        </a-descriptions-item>
        <a-descriptions-item label="货品三级分类">
          {{detail.goodsLevels}}
        </a-descriptions-item>
        <a-descriptions-item v-if="detail.brand" label="品牌">
          {{detail.brand}}
        </a-descriptions-item>
        <a-descriptions-item label="规格">
          {{detail.skuSpec}}
        </a-descriptions-item>
      </a-descriptions>
    </block-title>
    <block-title
      title="计量信息"
      :show-line="false"
      class="descriptions-block"
    >
      <a-descriptions
        bordered
        :column="3"
        class="descriptions"
        size="small"
      >
        <a-descriptions-item label="整单位">
          {{detail.bigUnit}}
        </a-descriptions-item>
        <a-descriptions-item label="零单位">
          {{detail.smallUnit}}
        </a-descriptions-item>
        <a-descriptions-item label="换算率">
          {{detail.conversionRate}}
        </a-descriptions-item>
        <a-descriptions-item label="默认单位">
          {{detail.defaultUnit}}
        </a-descriptions-item>
        <a-descriptions-item label="重量(整单位)">
          {{detail.weight}}
        </a-descriptions-item>
        <a-descriptions-item label="长(cm)">
          {{detail.length}}
        </a-descriptions-item>
        <a-descriptions-item label="宽(cm)">
          {{detail.wide}}
        </a-descriptions-item>
        <a-descriptions-item label="高(cm)">
          {{detail.hight}}
        </a-descriptions-item>
      </a-descriptions>
    </block-title>
    <block-title
      title="质控信息"
      :show-line="false"
      :column="3"
      class="descriptions-block"
    >
      <a-descriptions
        bordered
        :column="3"
        class="descriptions"
        size="small"
      >
        <a-descriptions-item label="是否保质期商品">
          {{detail.isShelfLife}}
        </a-descriptions-item>
        <a-descriptions-item label="保质期(天)">
          {{detail.shelfLife}}
        </a-descriptions-item>
        <a-descriptions-item label="允收期(天)">
          {{detail.dueInDays}}
        </a-descriptions-item>
        <a-descriptions-item label="允出期(天)">
          {{detail.dueOutDays}}
        </a-descriptions-item>
        <a-descriptions-item label="是否越库">
          {{detail.isOverWarehouse}}
        </a-descriptions-item>
        <a-descriptions-item label="是否解冻">
          {{detail.isUnfreeze}}
        </a-descriptions-item>
        <a-descriptions-item label="是否易碎">
          {{detail.isFragile}}
        </a-descriptions-item>
        <a-descriptions-item label="温层">
          {{detail.temperatureLayerName}}
        </a-descriptions-item>
        <a-descriptions-item v-if="detail.saleStock" label="安全库存">
          {{detail.saleStock}}
        </a-descriptions-item>
        <a-descriptions-item label="批属性规则">
          {{detail.batchAttributeName}}
        </a-descriptions-item>
      </a-descriptions>
    </block-title>
  </a-modal>
</template>

<script>
import BlockTitle from '@/components/panel/BlockTitle.vue'
import { getReplenishmentDetail } from '../../api';

export default {
  name: 'ReplenishmentDetail',
  components: {
    BlockTitle
  },
  data() {
    return {
      visible: false,
      detail: {},
    }
  },
  methods: {
    show(record) {
      this.visible = true
      this.getDetail(record)
    },
    async getDetail(record) {
      const res = await getReplenishmentDetail({
        size: 10,
        from: 0,
        filter: {
          shipperGoodsCode: record.shipperGoodsCode, // 货主货品编码
          customerCode: record.customerCode,  // 客户
          tenantId : record.warehouseId // 公司
        },
        "sort": [],
        "by_field": [],
        "paging": true
      })
      this.detail = res.records?.[0] || {}
    },
    handleCancel() {
      this.visible = false
    }
  }
}
</script>
<style lang="less" scoped>
.replenishment-detail {
  ::v-deep .ant-modal-body {
    padding: 0 0 32px 0;
  }
  .descriptions-block {
    padding-top: 32px;
    .descriptions {
      padding: 0 32px;
      ::v-deep .ant-descriptions-row {
        .ant-descriptions-item-label  {
          width: 120px;
          text-align: right;
          padding: 12px 16px 12px 0;
        }
      }
    }
  }
}
</style>
